import {AfterViewInit, Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {HomonymUiBox} from "./homonym-ui-box";
import {Homonym} from "../../shared/models/homonym.model";
import {HomonymListItemComponent} from "./homonym-list-item.component";


@Component({
  selector: 'app-homonym-box',
  template: `
    <div class="list-inner-wrap">
      <ul>
        <li *ngFor="let homonym of homonymBox.listHomonym"
            [style.padding-left]="homonym.paddingLeft + 'px'"
            [style.padding-top]="homonym.paddingTop + 'px'"
            id="{{ 'homonym_'+homonym.name }}">
          <app-homonym-list-item [homonym]="homonym"
                                 (afterViewInit)="onAfterViewInit($event)"
                                 (click)="selectItem.emit(homonym)"></app-homonym-list-item>
        </li>
      </ul>
    </div>
  `,
})
export class HomonymBoxComponent implements AfterViewInit {
  @HostBinding('style.display') styleBlock = 'block';
  @Input() homonymBox?: HomonymUiBox;
  @Output() selectItem = new EventEmitter<Homonym>();

  // 내부의 첫번째 Homonym 요소가 모두 그려졌을 때 불려짐. 이 정보를 이용해서 크기를 판단하고 CSS를 변경한다.
  @Output() afterViewInit = new EventEmitter<HomonymListItemComponent>()

  @HostBinding('class') get classList(): string {
    return 'list-box type-' + this.homonymBox.type;
  }

  @HostBinding('style.visibility')
  get styleVisible(): string {
    return this.homonymBox?.visible ?? false ? 'visible' : 'hidden';
  }

  protected firstHomonymComponent: HomonymListItemComponent;

  private numChildAfterViewInit = 0;

  constructor() { }

  ngAfterViewInit() {
    if (this.firstHomonymComponent) {
      this.afterViewInit.emit(this.firstHomonymComponent);
    }
    else {
      console.error('HomonymBoxComponent::ngAfterViewInit() firstHomonymComponent is null');
    }
  }

  onAfterViewInit(listItemComponent: HomonymListItemComponent) {
    ++this.numChildAfterViewInit;

    if (!this.firstHomonymComponent) {
      this.firstHomonymComponent = listItemComponent;
    }

    if (this.numChildAfterViewInit === this.homonymBox.listHomonym.length) {
      const offsetTop = this.firstHomonymComponent.eRef.nativeElement.offsetTop;

      this.homonymBox.listHomonym.forEach(homonym => {
        homonym.offsetTop = offsetTop;
      });
    }
  }
}
